import styled, { css } from "styled-components";
import BaseLayout from "../BaseLayout/BaseLayout";

export const BackgroundLayoutRoot = styled(BaseLayout)(
    ({ theme }) => css`
        background: ${theme.palette.primary};
        padding: ${theme.spacing.all(16)};
    `,
);
